import type { ServerListParams } from '@crm/shared';
import { createCrudThunks } from '../../store/createCrudThunks';
import { noteApi } from './noteApi';
import type { Note, NoteCreatePayload, NoteUpdatePayload } from './noteTypes';

const thunks = createCrudThunks<Note, NoteCreatePayload, NoteUpdatePayload, ServerListParams>(
  'notes',
  noteApi,
);

export const noteThunks = thunks;
export const {
  fetchAll: fetchNotes,
  fetchOne: fetchNote,
  create: createNote,
  update: updateNote,
  remove: deleteNote,
} = thunks;
